export function getAdIdFromUrl(): string | null {
    const params = new URLSearchParams(window.location.search)
    const urlAdId = params.get("ad_id")
    if (urlAdId) {
        setAdIdToStorage(urlAdId)
        return urlAdId
    }
    return getAdIdFromStorage()
}

export function setAdIdToStorage(adId: string) {
    try {
        localStorage.setItem("ad-id", adId)
    } catch (e) {
        // ignore
    }
}

export function getAdIdFromStorage(): string | null {
    try {
        return localStorage.getItem("ad-id")
    } catch (e) {
        return null
    }
}
